import { ImagesType } from "./type";

export const getImageUrlFromSteps = (steps: ImagesType["steps"]) => {
  return steps.filter((s) => s.result_url).pop()?.result_url || "";
};

export const getImageSizeFromSteps = (steps: ImagesType["steps"]) => {
  return (
    steps.filter((s) => s.result_url).pop()?.size || { width: 512, height: 512 }
  );
};
